<!-- Rotas públicas (sem layout) -->
<ng-container *ngIf="isPublicRoute">
    <router-outlet></router-outlet>
</ng-container>

<!-- Rotas privadas (com layout) -->
<ng-container *ngIf="!isPublicRoute">
    <!-- vertical-layout -->
    <ng-container *ngIf="coreConfig.layout.type === 'vertical'">
        <vertical-layout></vertical-layout>
    </ng-container>
    <!-- / vertical-layout -->

    <!-- horizontal-layout -->
    <ng-container *ngIf="coreConfig.layout.type === 'horizontal'">
        <horizontal-layout></horizontal-layout>
    </ng-container>
    <!-- / horizontal-layout -->
</ng-container>

